<template>
  <div class="dishForm">
    <h3 class="dishForm__heading">
      {{ heading }}
    </h3>

    <form class="dishForm__form" onsubmit="return false">

      <justSelectForm @fillForm="fillFormWithReceivedData"
                      :class="{'justSelectForm--visible': buttons.edit}">
      </justSelectForm>

      <label for="dish-name">Nazwa dania</label>
      <input type="text"
             id="dish-name"
             class="dishForm__form__textField"
             required
             v-model='dish.name'>

      <label for="dish-price">Cena dania</label>
      <input type="number"
             id="dish-price"
             class="dishForm__form__textField"
             required
             v-model="dish.price">

      <label for="dish-description">Opis dania</label>
      <textarea id="dish-description"
                class="dishForm__form__textField"
                required
                v-model="dish.description">
      </textarea>

      <label for="dishType">Typ dania</label>
      <select name="dishType"
              id="dishType"
              class="dishForm__form__selectMenu"
              v-model="dish.type"
              required>

        <optgroup label="Menu zwykłe">
          <option value="starter">Przystawka</option>
          <option value="soup">Zupa</option>
          <option value="veganDish">Danie wegetariańskie</option>
          <option value="meatDish">Danie mięsne</option>
          <option value="fish">Ryby</option>
          <option value="salad">Sałaty</option>
          <option value="pasta">Pasty</option>
          <option value="dessert">Deser</option>
        </optgroup>

        <optgroup label="Menu dla dzieci">
          <option value="kids">Dla dzieci</option>
        </optgroup>

        <optgroup label="Alkohole">
          <option value="alcohol-wineWhite">Wino białe</option>
          <option value="alcohol-wineRed">Wino czerwone</option>
          <option value="alcohol-wineMuss">Wino musujące</option>
          <option value="alcohol-beer">Piwo</option>
          <option value="alcohol-strong">Mocne alkohole</option>
        </optgroup>

      </select>

      <input type="submit"
             :value="textOnButton"
             class="dishForm__form__button add"
             :class="{'dishForm__form__button--visible': buttons.add}"
             @click="addDishToDatabase">

      <input type="submit"
             :value="textOnButton"
             class="dishForm__form__button edit"
             :class="{'dishForm__form__button--visible': buttons.edit}"
             @click="editExistingDish">

      <span class="dishForm__form__reply"
            :class="{'dishForm__form__reply--visible': replyMessageVisible}">
        {{ replyMessageFirstWord }} dania odbyło się pomyślnie.
      </span>
    </form>
  </div>
</template>

<script>
import { db } from '../../firebase'
import justSelectForm from './justSelectForm'

export default {
  name: 'dishForm',
  data() {
    return {
      dish: {
        name: '',
        price: '',
        description: '',
        type: '',
      },
      buttons: {
        add: false,
        edit: false
      },
      replyMessageVisible: false,
      replyMessageFirstWord: ''
    }
  },
  components: { justSelectForm },
  props: ['heading', 'textOnButton', 'type'],
  methods: {
    addDishToDatabase () {
      let id = Math.floor(Math.random() * 1000),
          dishId = `dish${id}`,
          isAnyFieldEmpty = this.checkIfFormHasEmptyFields();

      if (isAnyFieldEmpty === false) {
        db.collection('dishes').doc(this.chooseTheRightCategory())
          .set({
              [dishId]: {
                id: id,
                name: this.dish.name,
                price: this.dish.price,
                description: this.dish.description,
                type: this.dish.type
              }
            },
            {merge: true});

        this.showReplyMessage(`Dodawanie`);
        this.clearFormAfterAdding();
        this.hideReplyAfterTwoSeconds();
      }
    },
    editExistingDish () {
      console.log(this.dish)
      let dishId = `dish${this.dish.id}`

      db.collection('dishes').doc(this.chooseTheRightCategory())
        .set({
          [dishId]: {
            id: this.dish.id,
            name: this.dish.name,
            price: this.dish.price,
            description: this.dish.description,
            type: this.dish.type
          }
        }, {merge: true})

      this.showReplyMessage(`Edycja`);
      this.clearFormAfterAdding();
      this.hideReplyAfterTwoSeconds();
    },
    chooseTheRightCategory () {
      if (this.dish.type.includes(`kids`)) return `forKids`
      else if (this.dish.type.includes(`alcohol-`)) return `alcohol`
      else return `normal`
    },
    chooseTheRichCategoryFromReceivedData(data) {
      if (data.includes(`kids`)) return `forKids`
      else if (data.includes(`alcohol-`)) return `alcohol`
      else return `normal`
    },
    showReplyMessage (firstWord) {
      this.replyMessageFirstWord = firstWord
      this.replyMessageVisible = true
    },
    clearFormAfterAdding () {
      for (let element in this.dish) {
        this.dish[element] = ''
      }
    },
    hideReplyAfterTwoSeconds () {
      setTimeout(() => {
        this.replyMessageVisible = false
      }, 2000)
    },
    checkIfFormHasEmptyFields () {
      let result;

      for (let element in this.dish) {
        if (this.dish[element] === '') result = true;
        else result = false;
      }

      return result;
    },
    fillFormWithReceivedData (receivedData) {
      let chooseCategory = this.chooseTheRichCategoryFromReceivedData(receivedData.category);
      db.collection("dishes").doc(chooseCategory).get().then(doc => {
        let data = doc.data();

        for (let doc in data) {
          if (data[doc].name === receivedData.name) this.dish = data[doc]
        }
      })
    }
  },
  created () {
    if (this.type === 'add') this.buttons.add = true
    else this.buttons.edit = true
  }
}
</script>
